import React from 'react';
import IconType from './iconType';

export default function AddIcon({ color = 'white', height = 28, width = 29 }: IconType) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 29 28" fill="none">
      <path
        d="M14.5065 25.6536C20.95 25.6536 26.1732 20.4305 26.1732 13.987C26.1732 7.54348 20.95 2.32031 14.5065 2.32031C8.06301 2.32031 2.83984 7.54348 2.83984 13.987C2.83984 20.4305 8.06301 25.6536 14.5065 25.6536Z"
        stroke={color}
        strokeWidth="2.33333"
        strokeLinejoin="round"
      />
      <path
        d="M14.5065 9.32031V18.6536M9.83984 13.987H19.1732"
        stroke={color}
        strokeWidth="2.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
